import 'babel-polyfill';
import { instance } from '../utils/axiosInstance'


export class PayMethodsApi {
    static async send(pay_method) {
        return instance.post('/card_interest', pay_method)
       
    }

    static async getList(){
        return instance.get('/card_interests');
    }
    static async delete(data){
        return instance.delete('/card_interests/' + data)
    }
}


// WEBPACK FOOTER //
// ./src/api/paymethods_api.js